/** Design values for the skip / extra-date popover panel. Consumed only by exception.popover.component.less. */
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const exceptionPopoverStyleId = 'wb-v2-schedule-exception-popover-theme';

export const exceptionPopoverBridgeStyles = {
  'wb-schedule-exception-popover': {
    '--local-popover-width': '360px',
    '--local-popover-bg': tokens.color.background.primary,
    '--local-popover-border': tokens.color.border.secondary,
    '--local-popover-radius': tokens.radius.lg,
    '--local-popover-shadow': tokens.shadow.lg,
    '--local-popover-padding': tokens.spacing.xl,
    '--local-popover-gap': tokens.spacing.lg,
    '--local-popover-font-family': tokens.font.family.body,

    '--local-popover-title-color': tokens.color.text.primary,
    '--local-popover-title-font-size': tokens.font.size.textLg,
    '--local-popover-title-font-weight': tokens.font.weight.semibold,
    '--local-popover-title-line-height': tokens.lineHeight.textLg,

    '--local-popover-close-color': tokens.color.foreground.quaternary,
    '--local-popover-close-hover-color': tokens.color.foreground.secondary,
    '--local-popover-close-size': '24px',

    '--local-popover-label-color': tokens.color.text.secondary,
    '--local-popover-label-font-size': tokens.font.size.textSm,
    '--local-popover-label-font-weight': tokens.font.weight.medium,
    '--local-popover-label-line-height': tokens.lineHeight.textSm,
    '--local-popover-field-gap': tokens.spacing.xs,
    '--local-popover-row-gap': tokens.spacing.md,

    '--local-popover-control-bg': tokens.color.background.primary,
    '--local-popover-control-border': tokens.color.border.primary,
    '--local-popover-control-focus-border': tokens.color.border.brand,
    '--local-popover-control-radius': tokens.radius.sm,
    '--local-popover-control-padding-y': tokens.spacing.md,
    '--local-popover-control-padding-x': tokens.spacing.lg,
    '--local-popover-control-color': tokens.color.text.primary,
    '--local-popover-control-font-size': tokens.font.size.textMdBase,
    '--local-popover-control-line-height': tokens.lineHeight.textMd,
    '--local-popover-control-placeholder': tokens.color.text.placeholder,

    // Amber for a skip (work is being removed), green for an extra (work is being added). Both are the
    // 50/200/700 rung of the utility ramp: no semantic token exists for a subtle informational banner.
    '--local-popover-impact-radius': tokens.radius.sm,
    '--local-popover-impact-padding-y': tokens.spacing.md,
    '--local-popover-impact-padding-x': tokens.spacing.lg,
    '--local-popover-impact-font-size': tokens.font.size.textSm,
    '--local-popover-impact-line-height': tokens.lineHeight.textSm,
    '--local-popover-impact-skip-bg': tokens.componentColors.utility.warning50,
    '--local-popover-impact-skip-border': tokens.componentColors.utility.warning200,
    '--local-popover-impact-skip-color': tokens.componentColors.utility.warning700,
    '--local-popover-impact-extra-bg': tokens.componentColors.utility.success50,
    '--local-popover-impact-extra-border': tokens.componentColors.utility.success200,
    '--local-popover-impact-extra-color': tokens.componentColors.utility.success700,

    '--local-popover-footer-gap': tokens.spacing.md,
  },
};
